import { LOCATION_CHANGE } from 'react-router-redux';
import URL from 'url';
import { CACHE_LOCATION_FROM_URL } from './constants';

export default function locationReducer(state = {}, action = {}) {
    // this is meant to be fired in fetchData on each page
    if (action.type === CACHE_LOCATION_FROM_URL) {
        return action.payload;

    // this keeps the reducer in sync with react-router
    } else if (action.type === LOCATION_CHANGE && typeof window !== 'undefined') {
        return URL.parse(window.location.href, true);
    }

    return state;
}
